import { get } from './requests.js'

export const getEntity = async (entity, id) => get([entity, id])
